angular.module('filters').filter('waiverGymAddress', function() {
  return function(waiver) {
    return _.compact([waiver.waiver_header_address_suburb, waiver.waiver_header_address_state, waiver.waiver_header_address_postcode, waiver.waiver_header_address_country]).join(', ');
  };
});
